import { Request } from 'crono-fe-common/types/request';
import client from 'utils/clients/client';
import { ENDPOINTS } from 'config/endpoints';
import { ChartMogulSettings } from 'crono-fe-common/types/chartMogulSettings';

export type ChartMogulVerifyIntegrationResult = {
  data: { isSuccess: boolean; data?: ChartMogulSettings };
};

class ChartMogulService {
  private _alreadyRunningVerifyChartMogulIntegrationCall: Promise<ChartMogulVerifyIntegrationResult> | null =
    null;

  public async verifyChartMogulIntegration(): Promise<ChartMogulVerifyIntegrationResult> {
    if (this._alreadyRunningVerifyChartMogulIntegrationCall) {
      return await this._alreadyRunningVerifyChartMogulIntegrationCall;
    } else {
      this._alreadyRunningVerifyChartMogulIntegrationCall =
        this._verifyChartMogulIntegration();
      try {
        const verifyResult =
          await this._alreadyRunningVerifyChartMogulIntegrationCall;
        return verifyResult;
      } catch (e) {
        return {
          data: {
            isSuccess: false,
          },
        };
      } finally {
        this._alreadyRunningVerifyChartMogulIntegrationCall = null;
      }
    }
  }

  private async _verifyChartMogulIntegration(): Promise<ChartMogulVerifyIntegrationResult> {
    const request: Request = {
      url: ENDPOINTS.chartMogul.verify,
      config: {
        method: 'get',
      },
    };

    const result = await client(request);
    return result as ChartMogulVerifyIntegrationResult;
  }
}

// I export a single instance of the service, so that all other files that import
// this file will always import the same instance
export default new ChartMogulService();
